export default __webpack_public_path__ + "static/media/stickers_img.b6fad10e.png";